export const CryptoPaymentDepositCurrencyIcon = ({ currencyCode, width, height }) => {
  const options = {
    width: width || '16',
    height: height || '16'
  }

  return (
    <img
      style={{ width: `${options.width}px`, height: `${options.height}px` }}
      src={`${process.env.PUBLIC_URL}/content/images/icons/crypto-icon-${currencyCode.toLowerCase()}.png`}
      alt={currencyCode}
    />
  )
}
